import { all, call } from "redux-saga/effects";
import onGetFeedback from "./getAllFeedback";
import onPostFeedback from "./postFeedback";

export default function* feedbackSagas() {
  yield all([call(onGetFeedback), call(onPostFeedback)]);
}
